/*
 * Copyright (C) 2023 - present Marek Kuzora - All Rights Reserved.
 */


import { Client } from 'fierry/flux';

import GalaxyOne from 'astro/fake/galaxy.one';
import GalaxyTwo from 'astro/fake/galaxy.two';
import GalaxyThree from 'astro/fake/galaxy.three';
import GalaxyFour from 'astro/fake/galaxy.four';
import GalaxyFive from 'astro/fake/galaxy.five';

import GalaxyState from 'astro/fake/state/galaxy';


export default new Client ([], class
{
  constructor ()
  {
    this.galaxies = [];

  }


  getGalaxy (route, args)
  {
    /*let index = Number.parseInt(route.getArgs().index);

    if (Number.isNaN(index))
    {
      index = 5;
    }*/

    return this.__getLazyGalaxy__(1);
  }


  __getLazyGalaxy__ (type)
  {
    if (this.galaxies[type] == null)
    {
      this.galaxies[type] = this.__createGalaxy__(type);
    }

    return this.galaxies[type];
  }


  __createGalaxy__ (type)
  {
    switch (type)
    {
      case 1: return GalaxyState(GalaxyOne());
      case 2: return GalaxyState(GalaxyTwo());
      case 3: return GalaxyState(GalaxyThree());
      case 4: return GalaxyState(GalaxyFour());
      case 5: return GalaxyState(GalaxyFive());
    }
  }


});
